import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { acuerdo_documento_reeleccionconsecutiva } from 'src/app/interfaces/acuerdo_documento_reeleccionconsecutiva.interface';
import { ContendientesService } from 'src/app/services/contendientes.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit {
  loading: boolean = false;
  listadoDocumentosAcuerdos: acuerdo_documento_reeleccionconsecutiva[] = [];

  // documentos: any[] = [
  //   {
  //     url: 'http://www.diputados.gob.mx/eleccion-2021/docs/CONVENIO_INE.pdf',
  //     urlImagen:
  //       'http://www.diputados.gob.mx/eleccion-2021/images/convenio_01.png',
  //     titulo: 'Convenio de Colaboración',
  //     descripcion:
  //       'Convenio de Colaboración entre el INE y la Cámara de Diputados del H. Congreso de la Unión.',
  //     extension: 'pdf',
  //   },
  //   {
  //     url: 'https://portalhcd.diputados.gob.mx/EleccionConsecutiva/Documentos/Acuerdo_Diputados.pdf',
  //     urlImagen:
  //       'https://portalhcd.diputados.gob.mx/EleccionConsecutiva/Documentos/acuerdo_diputados.png',
  //     titulo: 'Acuerdo',
  //     descripcion: 'Acuerdo de Órganos de Gobierno',
  //     extension: 'pdf',
  //   },
  // ];
  constructor(private rModule: RouterModule,
    private api: ContendientesService,
    ) {}

  ngOnInit(): void {

    this.loading = true;
    
    this.api.getallDocumentosAcuerdos_ReeleccionConsecutiva().subscribe((data) => {
       this.listadoDocumentosAcuerdos = data;
      //  console.log(data);
      // this.contendientes.forEach((element: Contendiente) => {
      //   const myData = copy(element);
      //   myData.Tipo = myData.NombreArchivo
      //     ? myData.NombreArchivo.split('.')[1]
      //     : myData.NombreArchivo;
      //   element = myData;
      //   // console.log(element);
       });
      this.loading = false;

  }
}